/* DIYUK project calculators: pergola, decking, fence. No dependencies.
   Formulas: szablon_diyuk/kalkulatory/ZALOZENIA.md (user 13.10.2026 13:22:44 BST "E1 a"; numbers W1-W5, P1-P8, T1-T8, F1-F5 below).
   Post supports: szablon_diyuk/kalkulatory/RODZAJE_PODSTAW.md. */
(() => {
  const root = document.querySelector('[data-calc]');
  if (!root) return;
  const D = window.DIYUK || {};
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
  const KIND = root.dataset.calc;
  const T = JSON.parse($('[data-calc-strings]').textContent);
  const PRODUCTS = JSON.parse($('[data-calc-products]').textContent);
  const byHandle = Object.fromEntries(PRODUCTS.map((p) => [p.handle, p]));
  const fill = (s, map) => String(s).replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* Money: same rules as assets/theme.js and snippets/price-calc.liquid */
  const formatMoney = (pence) => {
    const fmt = D.money || '£{{amount}}';
    const two = (Math.round(pence) / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(pence / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, two.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/<[^>]*>/g, '');
  };
  /* The cart takes the store-wide discount from the whole order (order discount, Shopify Admin 13.10.2026 15:09:19),
     so full prices are added up first and the discount is rounded once, as in the cart */
  const promoPercent = () => (D.promo && D.promo.mode !== 'none') ? Number(D.promo.percent || 0) : 0;
  const promoTotal = (full) => full - Math.round(full * promoPercent() / 100);
  const exVat = (p) => Math.round(p / (1 + Number(D.vatRate || 20) / 100));
  /* Table: Total = cart total; each row = its own discounted price, the last row takes the rounding rest so the rows add up to Total; ex VAT the same way from Total */
  const tableMoney = (fulls) => {
    const total = promoTotal(fulls.reduce((s, x) => s + x, 0));
    const ex = exVat(total);
    const rows = fulls.map(promoTotal);
    if (rows.length) rows[rows.length - 1] += total - rows.reduce((s, x) => s + x, 0);
    const rowsEx = rows.map(exVat);
    if (rowsEx.length) rowsEx[rowsEx.length - 1] += ex - rowsEx.reduce((s, x) => s + x, 0);
    return { total, ex, rows, rowsEx };
  };

  /* Products named in ZALOZENIA.md */
  const H = {
    bracket: 'heavy-duty-galvanised-angle-brackets-2mm-steel-l-corner-brace', // P4, P5, T4, T5
    screws: 'multi-purpose-wood-screws-yzp-pozi-countersunk', // P6, T5, T6, F5
    coach: 'm10-hex-head-coach-screws-bzp-lag-bolts', // P7, T8
    adjustable: 'adjustable-metal-post-support-bracket-0-200mm', // T7
    cap: 'diyuk-70mm-x-70mm-galvanised-steel-pyramid-fence-post-caps', // F3
    panelBracket: 'galvanised-l-shaped-fence-panel-brackets-30x38x30mm' // F4
  };
  /* P5: "Fixing holes (5mm)" column of the size table in the bracket description (read 13.10.2026 13:12:43) */
  const HOLES = {
    '40x40x40': 8, '40x40x60': 12, '40x40x100': 20, '40x40x200': 40,
    '60x60x40': 12, '60x60x60': 18, '60x60x80': 24, '60x60x100': 30,
    '80x80x40': 16, '80x80x60': 24, '80x80x80': 32, '80x80x100': 40,
    '100x100x60': 30, '100x100x80': 40, '100x100x100': 50
  };
  /* P3, F2: fixing type per product (RODZAJE_PODSTAW.md section 1). Products not listed here are left out. */
  const SUPPORT_KIND = {
    'heavy-duty-galvanised-bolt-down-square-fence-post-support-bracket': 'bolt',
    'heavy-duty-galvanised-bolt-down-u-post-support-base-bracket': 'bolt',
    'galvanised-post-support-foot-bracket-open-shoe-heavy-duty-for-fence-fixing': 'bolt',
    'heavy-duty-adjustable-bolt-down-fence-post-support-bracket': 'bolt',
    'adjustable-metal-post-support-bracket-0-200mm': 'bolt',
    'adjustable-fence-post-support-bracket-100-150mm-bolt-down': 'bolt',
    'heavy-duty-4mm-galvanised-u-shape-bolt-down-fence-post-support': 'bolt',
    'heavy-duty-4mm-galvanised-elevated-bolt-down-post-base-bracket': 'bolt',
    'diyuk-pso': 'bolt',
    'heavy-duty-galvanised-concealed-shoe-fence-post-base-bracket-bolt-down': 'bolt',
    'heavy-duty-galvanised-concealed-post-support-bracket': 'concrete',
    'heavy-duty-u-shape-post-support-base-bracket-concrete-in': 'concrete',
    'heavy-duty-l-shape-post-support-bracket-concrete-in': 'concrete',
    'heavy-duty-galvanised-drive-in-fence-post-support-spike': 'drive',
    'heavy-duty-fence-post-spike-ground-screw-anchor-support': 'screw'
  };
  const KINDS = ['bolt', 'concrete', 'drive', 'screw'];
  /* P8: descriptions that say fixings are not included; true = they name coach screws (RODZAJE_PODSTAW.md section 4) */
  const NOT_INCLUDED = {
    'heavy-duty-galvanised-bolt-down-square-fence-post-support-bracket': true,
    'heavy-duty-galvanised-bolt-down-u-post-support-base-bracket': true,
    'heavy-duty-adjustable-bolt-down-fence-post-support-bracket': true,
    'heavy-duty-fence-post-spike-ground-screw-anchor-support': true,
    'heavy-duty-4mm-galvanised-elevated-bolt-down-post-base-bracket': false
  };
  const COLOURS = ['SILVER', 'GOLD', 'BLACK', 'ANTHRACITE'];

  /* Variants: the pack option is the one named pack or quantity; its value starts with the piece count ("Pack of: 4", "10 pcs", "4") */
  const packIndex = (p) => p.options.findIndex((n) => /pack|quantity/i.test(n));
  const packQty = (p, v) => {
    const i = packIndex(p);
    if (i < 0) return 1;
    const m = String(v.options[i]).match(/\d+/);
    return m ? Math.max(1, parseInt(m[0], 10)) : 1;
  };
  const groupOf = (p, v) => { const i = packIndex(p); return v.options.filter((o, j) => j !== i).join(' / '); };
  const groupsOf = (p) => {
    const out = [];
    p.variants.forEach((v) => { const g = groupOf(p, v); if (!out.includes(g)) out.push(g); });
    return out.filter((g) => !/\btool\b/i.test(g));
  };
  const groupLabel = (g) => (!g || g === 'Default Title' ? T.oneSize : g);
  const colourOf = (g) => { const m = String(g).toUpperCase().match(/\b(SILVER|GOLD|BLACK|ANTHRACITE)\b/); return m ? m[1] : ''; };
  const hasColours = (p) => groupsOf(p).some((g) => colourOf(g));
  /* W3: post size in mm from an option value (RODZAJE_PODSTAW.md section 2) */
  const postFit = (g) => {
    let s = String(g).split('/')[0];
    s = s.replace(/\([^)]*["″][^)]*\)/g, ' ');
    s = s.replace(/\d+(?:\.\d+)?\s*(?:mm)?\s*\(h\)/gi, ' ');
    s = s.replace(/\d+(?:\.\d+)?\s*["″]/g, ' ');
    const nums = (s.match(/\d+(?:\.\d+)?/g) || []).map(Number);
    if (!nums.length) return null;
    return nums.length > 1 ? Math.min(nums[0], nums[1]) : nums[0];
  };
  const sizeKey = (g) => (String(g).split('(')[0].match(/\d+(?:\.\d+)?/g) || []).map(Number);
  const bySize = (a, b) => { const x = sizeKey(a); const y = sizeKey(b); for (let i = 0; i < Math.max(x.length, y.length); i += 1) { const d = (x[i] ?? -1) - (y[i] ?? -1); if (d) return d; } return 0; };
  const firstNumber = (g) => { const m = String(g).match(/\d+(?:\.\d+)?/); return m ? Number(m[0]) : Infinity; };
  const holesFor = (g) => { const m = String(g).match(/^(\d+)x(\d+)x(\d+)x/); return m ? HOLES[`${m[1]}x${m[2]}x${m[3]}`] || null : null; };

  /* W2: cheapest combination of packs that gives at least `need` pieces.
     A pack can be limited by stock (`max` in the product data); without `max` any number of packs can be used.
     The packs of one size share one stock of pieces (Linnworks composite: stock of a pack = pieces / pack size, rounded down),
     so when every pack has `max` the pieces of all packs together stay within the largest max x pack size, never above that stock. */
  const offersFor = (p, g) => p.variants
    .filter((v) => v.available && groupOf(p, v) === g)
    .map((v) => ({ variant: v, pack: packQty(p, v), price: v.price, max: Number.isFinite(v.max) && v.max > 0 ? v.max : Infinity }));
  const cheapest = (offers, need) => {
    if (!offers.length || !(need > 0)) return null;
    const pool = offers.every((o) => Number.isFinite(o.max)) ? Math.max(...offers.map((o) => o.max * o.pack)) : Infinity;
    const limit = Math.min(need + Math.max(...offers.map((o) => o.pack)), pool);
    if (limit < need) return null;
    let cost = new Array(limit + 1).fill(Infinity);
    cost[0] = 0;
    const took = offers.map((o) => {
      const next = cost.slice();
      const k = new Array(limit + 1).fill(0);
      const cap = Math.min(o.max, Math.ceil(limit / o.pack));
      for (let c = 0; c <= limit; c += 1) {
        if (cost[c] === Infinity) continue;
        for (let n = 1; n <= cap && c + n * o.pack <= limit; n += 1) {
          const v = cost[c] + n * o.price;
          if (v < next[c + n * o.pack]) { next[c + n * o.pack] = v; k[c + n * o.pack] = n; }
        }
      }
      cost = next;
      return k;
    });
    let best = -1;
    for (let c = need; c <= limit; c += 1) if (cost[c] < Infinity && (best < 0 || cost[c] < cost[best])) best = c;
    if (best < 0) return null;
    const packs = [];
    for (let i = offers.length - 1, c = best; i >= 0; i -= 1) {
      const n = took[i][c];
      if (n) { packs.push({ offer: offers[i], count: n }); c -= n * offers[i].pack; }
    }
    packs.sort((a, b) => b.offer.pack - a.offer.pack);
    return { pieces: best, packs, full: packs.reduce((s, x) => s + x.count * x.offer.price, 0) };
  };

  /* Inputs. W1: lengths in cm or inches, post size in mm or inches */
  const form = $('[data-calc-form]');
  const state = { unit: 'cm', choice: {} };
  const field = (name) => $(`[data-field="${name}"]`);
  const parse = (v) => { const n = parseFloat(String(v).replace(',', '.')); return Number.isFinite(n) && n > 0 ? n : NaN; };
  const factor = (el) => ({ len: 2.54, post: 25.4 }[el.dataset.unitType] || 1);
  /* Metric value of a field (cm for lengths, mm for the post). After a unit switch the exact value is kept in data-base,
     so cm > in > cm gives back the same number and the same quantities. */
  const metric = (el) => {
    if (!el) return NaN;
    if (el.dataset.base !== undefined && el.dataset.shown === el.value) return Number(el.dataset.base);
    const v = parse(el.value);
    return state.unit === 'in' ? v * factor(el) : v;
  };
  const trim = (n, d) => String(Number(n.toFixed(d)));
  const show = (el, base) => {
    const f = factor(el);
    const text = f > 1 && state.unit === 'in' ? trim(base / f, 2) : trim(base, 2);
    el.dataset.base = String(base);
    el.value = text;
    el.dataset.shown = text;
  };
  const cm = (name) => metric(field(name));
  const mm = (name) => metric(field(name));
  const count = (name) => { const el = field(name); const v = el ? Math.floor(parse(el.value)) : NaN; return Number.isFinite(v) ? v : NaN; };
  const showLen = (vcm) => (state.unit === 'in' ? `${trim(vcm / 2.54, 1)} in` : `${trim(vcm, 1)} cm`);

  const setUnit = (unit, convert) => {
    const lens = $$('[data-field]').filter((el) => factor(el) > 1);
    const bases = convert ? lens.map(metric) : [];
    state.unit = unit;
    if (convert) lens.forEach((el, i) => { if (Number.isFinite(bases[i])) show(el, bases[i]); });
    $$('[data-unit-label="len"]').forEach((el) => { el.textContent = unit === 'in' ? 'in' : 'cm'; });
    $$('[data-unit-label="post"]').forEach((el) => { el.textContent = unit === 'in' ? 'in' : 'mm'; });
    $$('input[name="calc-unit"]').forEach((el) => { el.checked = el.value === unit; });
  };

  /* Size choices that do not depend on the dimensions */
  const choiceSelect = (name, label, p, def, labelFn) => {
    if (!p) return '';
    const gs = groupsOf(p).slice().sort(bySize);
    let value = state.choice[name];
    if (value === undefined) { value = def ? (gs.find((g) => g.startsWith(def)) || '') : ''; state.choice[name] = value; }
    const opts = gs.map((g) => `<option value="${esc(g)}"${g === value ? ' selected' : ''}>${esc(labelFn ? labelFn(g) : g)}</option>`).join('');
    return `<label class="calc-field"><span>${esc(label)}</span><select data-choice="${name}"><option value="">${esc(T.chooseSize)}</option>${opts}</select></label>`;
  };
  const bracketLabel = (g) => { const h = holesFor(g); return h ? `${g} (${fill(T.holes, { n: h })})` : g; };
  const renderChoices = () => {
    const box = $('[data-calc-choices]');
    if (!box) return;
    let html = '';
    if (KIND === 'pergola') {
      html += choiceSelect('bracketSize', T.labels.bracketSize, byHandle[H.bracket], '', bracketLabel);
      html += choiceSelect('screwSize', T.labels.bracketScrewSize, byHandle[H.screws], '4.0 x 40mm');
      html += choiceSelect('coachLength', T.labels.coachLength, byHandle[H.coach], '120mm');
    } else if (KIND === 'decking') {
      html += choiceSelect('bracketSize', T.labels.bracketSize, byHandle[H.bracket], '', bracketLabel);
      html += choiceSelect('screwSize', T.labels.bracketScrewSize, byHandle[H.screws], '4.0 x 40mm');
      html += choiceSelect('deckScrewSize', T.labels.deckScrewSize, byHandle[H.screws], '4.5 x 60mm');
      html += choiceSelect('coachLength', T.labels.coachLength, byHandle[H.coach], '');
    }
    box.innerHTML = html;
  };

  /* Post supports (P3, W3, F2): candidates of the chosen type with a size that fits the post */
  const supportCandidates = (kind, postMm, colour) => PRODUCTS
    .filter((p) => SUPPORT_KIND[p.handle] === kind)
    .map((p) => {
      let gs = groupsOf(p);
      const coloured = hasColours(p);
      if (coloured && colour) gs = gs.filter((g) => !colourOf(g) || colourOf(g) === colour); // a size without a colour word shows with every colour
      if (!gs.length) return null;
      const sized = gs.filter((g) => g && g !== 'Default Title');
      if (!sized.length) return { p, groups: gs, auto: gs[0], coloured };
      const fits = sized.map((g) => ({ g, fit: postFit(g) })).filter((x) => x.fit !== null && x.fit >= postMm);
      if (!fits.length) return null;
      fits.sort((a, b) => a.fit - b.fit || (colour ? (colourOf(b.g) === colour) - (colourOf(a.g) === colour) : 0) || firstNumber(a.g) - firstNumber(b.g));
      return { p, groups: sized, auto: fits[0].g, coloured };
    })
    .filter(Boolean)
    .map((x, i) => ({ ...x, i, stock: offersFor(x.p, x.auto).length > 0 }))
    .sort((a, b) => (b.stock - a.stock) || (a.i - b.i));

  const renderSupport = (need, postMm) => {
    const box = $('[data-calc-support]');
    if (!box) return null;
    const c = state.choice;
    if (!c.kind) c.kind = 'bolt';
    if (c.colour === undefined) c.colour = 'SILVER';
    const kindChips = KINDS.filter((k) => PRODUCTS.some((p) => SUPPORT_KIND[p.handle] === k))
      .map((k) => `<label class="chip"><input type="radio" name="calc-kind" value="${k}"${k === c.kind ? ' checked' : ''} data-choice="kind"><span>${esc(T.kinds[k])}</span></label>`).join('');
    const colourSet = COLOURS.filter((col) => PRODUCTS.some((p) => SUPPORT_KIND[p.handle] === c.kind && groupsOf(p).some((g) => colourOf(g) === col)));
    if (colourSet.length > 1 && !colourSet.includes(c.colour)) c.colour = colourSet.includes('SILVER') ? 'SILVER' : colourSet[0];
    const colourChips = colourSet.length > 1 ? colourSet
      .map((col) => `<label class="chip"><input type="radio" name="calc-colour" value="${col}"${col === c.colour ? ' checked' : ''} data-choice="colour"><span>${esc(T.colours[col])}</span></label>`).join('') : '';
    let html = `<fieldset class="calc-group"><legend>${esc(T.labels.fixingType)}</legend><div class="calc-chips">${kindChips}</div></fieldset>`;
    if (colourChips) html += `<fieldset class="calc-group"><legend>${esc(T.labels.colour)}</legend><div class="calc-chips">${colourChips}</div><p class="tiny muted">${esc(T.colourNote)}</p></fieldset>`;
    let picked = null;
    if (!(postMm > 0)) {
      html += `<p class="small muted">${esc(T.enterPost)}</p>`;
    } else {
      const cands = supportCandidates(c.kind, postMm, colourSet.length > 1 ? c.colour : '');
      if (!cands.length) {
        html += `<p class="small muted">${esc(fill(T.noSupport, { size: Math.round(postMm) }))}</p>`;
      } else {
        if (!cands.some((x) => x.p.handle === c.support)) { c.support = cands.length === 1 ? cands[0].p.handle : ''; c.supportSize = ''; }
        const cards = cands.map((x) => {
          const g = x.p.handle === c.support && c.supportSize && x.groups.includes(c.supportSize) ? c.supportSize : x.auto;
          const res = need > 0 ? cheapest(offersFor(x.p, g), need) : null;
          if (x.p.handle === c.support) picked = { p: x.p, g, groups: x.groups };
          const price = res ? formatMoney(promoTotal(res.full)) : (offersFor(x.p, g).length ? T.notEnoughShort : T.outOfStockShort);
          const img = x.p.image ? `<img src="${esc(x.p.image)}" alt="" width="64" height="64" loading="lazy">` : '';
          return `<label class="calc-card"><input type="radio" name="calc-support" value="${esc(x.p.handle)}"${x.p.handle === c.support ? ' checked' : ''} data-choice="support">`
            + `<span class="calc-card__body">${img}<span><strong>${esc(x.p.title)}</strong><span class="tiny muted">${esc(groupLabel(g))}</span>`
            + `<span class="small">${esc(fill(T.needed, { n: need }))}: ${esc(price)}</span></span></span></label>`;
        }).join('');
        html += `<fieldset class="calc-group"><legend>${esc(T.labels.supportProduct)}</legend><div class="calc-cards">${cards}</div></fieldset>`;
        if (picked && picked.groups.length > 1) {
          const opts = picked.groups.slice().sort(bySize).map((g) => `<option value="${esc(g)}"${g === picked.g ? ' selected' : ''}>${esc(g)}</option>`).join('');
          html += `<label class="calc-field"><span>${esc(T.labels.supportSize)}</span><select data-choice="supportSize">${opts}</select></label>`;
        }
      }
    }
    box.innerHTML = html;
    return picked;
  };

  /* Formulas per calculator */
  const lineFor = (key, need, handle, group, extra = {}) => ({ key, need, handle, group, ...extra });
  const compute = () => {
    const c = state.choice;
    const out = { counts: [], lines: [], ready: false };
    if (KIND === 'pergola') {
      const L = cm('length'); const W = cm('width');
      const ps = cm('postSpacing'); const rs = cm('rafterSpacing'); const post = Math.round(mm('postSize')); // whole mm: the store lists 71mm as 2.8"
      if (!(L > 0 && W > 0 && ps > 0 && rs > 0)) { renderSupport(0, post); return out; }
      const perRow = Math.max(2, Math.floor(L / ps) + 1); // P1
      const posts = 2 * perRow;
      const rafters = Math.max(2, Math.floor(L / rs) + 1); // P2
      const brackets = 4 * rafters + 2 * posts; // P4
      const holes = holesFor(c.bracketSize);
      out.counts = [['posts', posts], ['beams', 2], ['rafters', rafters]];
      const sup = renderSupport(posts, post); // P3
      out.lines.push(lineFor('supports', posts, sup ? sup.p.handle : '', sup ? sup.g : null, { note: sup ? sup.p.handle : '' }));
      out.lines.push(lineFor('brackets', brackets, H.bracket, c.bracketSize || null));
      out.lines.push(lineFor('bracketScrews', holes ? holes * brackets : null, H.screws, holes ? (c.screwSize || null) : null)); // P5, P6
      out.lines.push(lineFor('coach', 2 * posts, H.coach, c.coachLength || null)); // P7
      out.diagram = { type: 'pergola', L, W, perRow, rafters };
    } else if (KIND === 'decking') {
      const L = cm('length'); const W = cm('width'); const js = cm('joistSpacing'); const bw = cm('boardWidth');
      if (!(L > 0 && W > 0 && js > 0 && bw > 0)) return out;
      const boards = Math.ceil(W / (bw + 0.5)); // T1
      const joists = Math.max(2, Math.floor(L / js) + 1); // T2
      const bearers = Math.max(2, Math.floor(W / 120) + 1); // T3
      const padsPer = Math.max(2, Math.floor(L / 120) + 1);
      const pads = bearers * padsPer;
      const brackets = 4 * joists; // T4
      const holes = holesFor(c.bracketSize);
      out.counts = [['boards', boards], ['joists', joists], ['bearers', bearers], ['pads', pads]];
      out.lines.push(lineFor('brackets', brackets, H.bracket, c.bracketSize || null));
      out.lines.push(lineFor('bracketScrews', holes ? holes * brackets : null, H.screws, holes ? (c.screwSize || null) : null)); // T5
      out.lines.push(lineFor('boardScrews', 2 * boards * joists, H.screws, c.deckScrewSize || null)); // T6
      if (c.adjustable) out.lines.push(lineFor('adjustable', pads, H.adjustable, byHandle[H.adjustable] ? groupsOf(byHandle[H.adjustable])[0] : null)); // T7
      out.lines.push(lineFor('coach', 2 * pads, H.coach, c.coachLength || null)); // T8
      out.diagram = { type: 'decking', L, W, joists, bearers, padsPer };
    } else if (KIND === 'fence') {
      const L = cm('length'); const panel = cm('panelWidth'); const postMm = Math.round(mm('postSize'));
      const perJoint = Math.max(2, count('perJoint') || 2);
      const postCm = postMm / 10;
      if (!(L > 0 && panel > 0 && postMm > 0) || L <= postCm) { renderSupport(0, postMm); return out; }
      const panels = Math.ceil((L - postCm) / (panel + postCm)); // F1
      const posts = panels + 1;
      out.counts = [['panels', panels], ['posts', posts]];
      const sup = renderSupport(posts, postMm); // F2
      out.lines.push(lineFor('supports', posts, sup ? sup.p.handle : '', sup ? sup.g : null, { note: sup ? sup.p.handle : '' }));
      if (Math.round(postMm) === 70 && byHandle[H.cap]) out.lines.push(lineFor('caps', posts, H.cap, groupsOf(byHandle[H.cap])[0])); // F3
      out.lines.push(lineFor('panelBrackets', perJoint * 2 * panels, H.panelBracket, byHandle[H.panelBracket] ? groupsOf(byHandle[H.panelBracket])[0] : null)); // F4
      out.lines.push(lineFor('panelScrews', null, H.screws, null, { linkOnly: true })); // F5
      out.diagram = { type: 'fence', L, panel, postCm, panels };
    }
    out.ready = true;
    return out;
  };

  /* Resolve lines into packs; the same product option used twice becomes one line */
  const resolve = (lines) => {
    const rows = [];
    lines.forEach((ln) => {
      const p = byHandle[ln.handle];
      if (ln.linkOnly) { rows.push({ ...ln, p, labels: [ln.key] }); return; }
      const same = ln.group != null && rows.find((r) => r.handle === ln.handle && r.group === ln.group && !r.linkOnly);
      if (same && ln.need > 0) { same.need += ln.need; same.labels.push(ln.key); return; }
      rows.push({ ...ln, p, labels: [ln.key] });
    });
    rows.forEach((r) => {
      if (r.linkOnly) return;
      if (!r.p || r.group == null || !(r.need > 0)) { r.state = 'choose'; return; }
      r.result = cheapest(offersFor(r.p, r.group), r.need);
      r.state = r.result ? 'ok' : (offersFor(r.p, r.group).length ? 'short' : 'stock');
    });
    return rows;
  };

  /* Drawing (F): a light plan or elevation in SVG */
  const svgText = (x, y, t, anchor = 'middle') => `<text x="${x}" y="${y}" text-anchor="${anchor}">${esc(t)}</text>`;
  const drawPlan = (d) => {
    const Wv = 640; const Hv = 360; const pad = 48;
    const s = Math.min((Wv - 2 * pad) / d.L, (Hv - 2 * pad) / d.W);
    const w = d.L * s; const h = d.W * s; const x0 = (Wv - w) / 2; const y0 = (Hv - h) / 2;
    let g = `<rect x="${x0}" y="${y0}" width="${w}" height="${h}" class="calc-svg__area"/>`;
    const across = (n) => Array.from({ length: n }, (_, i) => x0 + (n > 1 ? (i * w) / (n - 1) : 0));
    if (d.type === 'pergola') {
      across(d.rafters).forEach((x) => { g += `<line x1="${x}" y1="${y0}" x2="${x}" y2="${y0 + h}" class="calc-svg__thin"/>`; });
      g += `<line x1="${x0}" y1="${y0}" x2="${x0 + w}" y2="${y0}" class="calc-svg__thick"/><line x1="${x0}" y1="${y0 + h}" x2="${x0 + w}" y2="${y0 + h}" class="calc-svg__thick"/>`;
      across(d.perRow).forEach((x) => { [y0, y0 + h].forEach((y) => { g += `<rect x="${x - 6}" y="${y - 6}" width="12" height="12" class="calc-svg__post"/>`; }); });
    } else {
      across(d.joists).forEach((x) => { g += `<line x1="${x}" y1="${y0}" x2="${x}" y2="${y0 + h}" class="calc-svg__thin"/>`; });
      Array.from({ length: d.bearers }, (_, j) => y0 + (d.bearers > 1 ? (j * h) / (d.bearers - 1) : 0)).forEach((y) => {
        g += `<line x1="${x0}" y1="${y}" x2="${x0 + w}" y2="${y}" class="calc-svg__thick"/>`;
        across(d.padsPer).forEach((x) => { g += `<circle cx="${x}" cy="${y}" r="5" class="calc-svg__post"/>`; });
      });
    }
    g += svgText(x0 + w / 2, y0 + h + 30, `${T.labels.length} ${showLen(d.L)}`);
    g += `<g transform="translate(${x0 + w + 30} ${y0 + h / 2}) rotate(90)">${svgText(0, 0, `${T.labels.width} ${showLen(d.W)}`)}</g>`;
    return `<svg viewBox="0 0 ${Wv} ${Hv}" role="img" aria-label="${esc(T.diagram)}">${g}</svg>`;
  };
  const drawFence = (d) => {
    const Wv = 640; const Hv = 220; const pad = 24;
    const total = d.panels * d.panel + (d.panels + 1) * d.postCm;
    const s = (Wv - 2 * pad) / total;
    const pw = Math.max(3, d.postCm * s); const top = 40; const ph = 120;
    let g = ''; let x = pad;
    for (let i = 0; i <= d.panels; i += 1) {
      g += `<rect x="${x}" y="${top - 10}" width="${pw}" height="${ph + 20}" class="calc-svg__post"/>`;
      x += pw;
      if (i < d.panels) { g += `<rect x="${x}" y="${top}" width="${d.panel * s}" height="${ph - 20}" class="calc-svg__area"/>`; x += d.panel * s; }
    }
    g += svgText(Wv / 2, top + ph + 40, `${T.labels.length} ${showLen(d.L)}`);
    return `<svg viewBox="0 0 ${Wv} ${Hv}" role="img" aria-label="${esc(T.diagram)}">${g}</svg>`;
  };

  /* Results */
  let lastRows = [];
  const packText = (r, pk) => (packIndex(r.p) < 0 ? fill(T.pieces, { count: pk.count }) : fill(T.packOf, { count: pk.count, pack: pk.offer.pack }));
  const render = () => {
    const out = compute();
    const counts = $('[data-calc-counts]'); const list = $('[data-calc-list]'); const diagram = $('[data-calc-diagram]');
    const addBtn = $('[data-calc-add]'); const missing = $('[data-calc-missing]');
    if (!out.ready) {
      counts.innerHTML = `<p class="small muted">${esc(T.enterDims)}</p>`;
      list.innerHTML = ''; diagram.innerHTML = ''; missing.hidden = true; addBtn.disabled = true; lastRows = [];
      return;
    }
    diagram.innerHTML = out.diagram.type === 'fence' ? drawFence(out.diagram) : drawPlan(out.diagram);
    counts.innerHTML = `<h2 class="calc-h">${esc(T.countsTitle)}</h2><ul class="calc-counts">${out.counts.map(([k, n]) => `<li><strong>${n}</strong><span>${esc(T.labels[k])}</span></li>`).join('')}</ul><p class="tiny muted">${esc(T.countsNote)}</p>`;
    const rows = resolve(out.lines);
    lastRows = rows;
    const priced = rows.filter((r) => !r.linkOnly && r.state === 'ok');
    const money = tableMoney(priced.map((r) => r.result.full));
    const todo = []; let stock = false;
    const body = rows.map((r) => {
      const label = r.labels.map((k) => T.labels[k]).join(' + ');
      const needText = r.need > 0 ? fill(T.needed, { n: r.need }) : '';
      const name = r.p ? `<a href="${esc(r.p.url)}${r.state === 'ok' ? `?variant=${r.result.packs[0].offer.variant.id}` : ''}">${esc(r.p.title)}</a>` : '';
      let packs = ''; let price = '';
      if (r.linkOnly) {
        packs = `<span class="small muted">${esc(T.screwsLink)}</span>`;
      } else if (r.state === 'ok') {
        packs = r.result.packs.map((pk) => esc(packText(r, pk))).join('<br>');
        const k = priced.indexOf(r);
        price = `${esc(formatMoney(money.rows[k]))}<br><span class="tiny muted">${esc(fill(T.exVat, { price: formatMoney(money.rowsEx[k]) }))}</span>`;
      } else if (r.state === 'stock' || r.state === 'short') {
        const one = !(r.p && groupsOf(r.p).length > 1);
        const msg = r.state === 'short' ? (one ? T.notEnoughOne : T.notEnough) : (one ? T.outOfStockOne : T.outOfStock);
        packs = `<span class="small">${esc(msg)}</span>`; stock = true;
      } else {
        packs = `<span class="small muted">${esc(T.chooseAbove)}</span>`; todo.push(label);
      }
      let note = '';
      if (r.key === 'supports' && r.note && r.note in NOT_INCLUDED) {
        note = `<br><span class="tiny muted">${esc(T.notIncluded)}${NOT_INCLUDED[r.note] && byHandle[H.coach] ? ` <a href="${esc(byHandle[H.coach].url)}">${esc(T.coachLink)}</a>` : ''}</span>`;
      }
      const option = r.group && r.group !== 'Default Title' && !r.linkOnly ? `<br><span class="tiny muted">${esc(r.group)}</span>` : '';
      return `<tr><td><strong>${esc(label)}</strong>${needText ? `<br><span class="tiny muted">${esc(needText)}</span>` : ''}</td><td>${name}${option}${note}</td><td>${packs}</td><td class="num">${price}</td></tr>`;
    }).join('');
    const supportNote = rows.some((r) => r.key === 'supports') ? `<p class="tiny muted">${esc(T.fixingsNote)}</p>` : '';
    list.innerHTML = `<h2 class="calc-h">${esc(T.listTitle)}</h2><div class="price-table-wrap"><table class="price-table calc-table"><thead><tr><th>${esc(T.item)}</th><th>${esc(T.product)}</th><th>${esc(T.packs)}</th><th class="num">${esc(T.price)}</th></tr></thead><tbody>${body}</tbody>`
      + `<tfoot><tr><th colspan="3">${esc(T.total)}</th><th class="num">${esc(formatMoney(money.total))}<br><span class="tiny muted">${esc(fill(T.exVat, { price: formatMoney(money.ex) }))}</span></th></tr></tfoot></table></div>${supportNote}`;
    const notes = [];
    if (todo.length) notes.push(fill(T.choose, { list: todo.join(', ') }));
    if (stock) notes.push(T.stockNote);
    missing.hidden = !notes.length;
    missing.textContent = notes.map((n) => (/[.!?]$/.test(n) ? n : `${n}.`)).join(' '); // each note ends as a sentence
    addBtn.disabled = !!todo.length || !rows.some((r) => r.state === 'ok');
  };

  /* Remember inputs (per viewer) and keep a share link with the dimensions only */
  const storeKey = `diyuk-calc-${KIND}`;
  const fieldValues = () => Object.fromEntries($$('[data-field]').map((el) => {
    const v = factor(el) > 1 ? metric(el) : parse(el.value);
    return [el.dataset.field, Number.isFinite(v) ? trim(v, 3) : ''];
  }));
  const save = () => {
    const values = fieldValues();
    try { localStorage.setItem(storeKey, JSON.stringify({ unit: state.unit, values })); } catch (e) { /* storage blocked */ }
    const params = new URLSearchParams(location.search); // keep other parameters (utm, view)
    params.set('u', state.unit);
    Object.entries(values).forEach(([k, v]) => { if (v !== '') params.set(k, v); else params.delete(k); });
    history.replaceState(null, '', `${location.pathname}?${params.toString()}${location.hash}`);
  };
  /* Saved values and link values are metric (cm, mm); u= is the unit shown */
  const load = () => {
    const params = new URLSearchParams(location.search);
    let unit = 'cm'; let values = null;
    if ($$('[data-field]').some((el) => params.has(el.dataset.field))) {
      unit = params.get('u') === 'in' ? 'in' : 'cm';
      values = Object.fromEntries($$('[data-field]').map((el) => [el.dataset.field, params.get(el.dataset.field) || '']));
    } else {
      try { const s = JSON.parse(localStorage.getItem(storeKey) || 'null'); if (s && s.values) { unit = s.unit === 'in' ? 'in' : 'cm'; values = s.values; } } catch (e) { /* storage blocked */ }
    }
    setUnit(unit, false);
    $$('[data-field]').forEach((el) => {
      const v = values ? parse(values[el.dataset.field]) : NaN;
      if (Number.isFinite(v)) { if (factor(el) > 1) show(el, v); else el.value = String(Math.floor(v)); }
      else if (unit === 'in' && factor(el) > 1 && Number.isFinite(parse(el.value))) show(el, parse(el.value));
    });
  };

  /* Events */
  form.addEventListener('submit', (e) => e.preventDefault());
  form.addEventListener('input', (e) => { if (e.target.matches('[data-field]')) { render(); save(); } });
  form.addEventListener('change', (e) => {
    const t = e.target;
    if (t.name === 'calc-unit') { setUnit(t.value, true); render(); save(); return; }
    if (t.dataset.choice) {
      const name = t.dataset.choice;
      state.choice[name] = t.type === 'checkbox' ? t.checked : t.value;
      if (name === 'kind' || name === 'colour') { state.choice.support = ''; state.choice.supportSize = ''; }
      if (name === 'support') state.choice.supportSize = '';
      render();
      const again = $(`[data-choice="${name}"]${t.type === 'radio' ? `[value="${CSS.escape(t.value)}"]` : ''}`);
      if (again) again.focus();
    }
  });

  const status = $('[data-calc-status]');
  const sectionsUrl = () => `${String(D.routes.root || '/').replace(/\/$/, '')}/?sections=cart-drawer`;
  const refreshCart = async (sections, open) => {
    let secs = sections;
    if (!secs) { try { secs = await (await fetch(sectionsUrl())).json(); } catch (e) { secs = null; } }
    const cart = await (await fetch(`${D.routes.cart}.js`)).json();
    if (document.querySelector('[data-cart-drawer]')) document.dispatchEvent(new CustomEvent('diyuk:cart-updated', { detail: { sections: secs, count: cart.item_count, open } }));
    else if (open) window.location.href = D.routes.cart;
  };
  $('[data-calc-add]').addEventListener('click', async (e) => {
    const btn = e.currentTarget;
    const items = [];
    lastRows.filter((r) => r.state === 'ok').forEach((r) => r.result.packs.forEach((pk) => {
      const id = pk.offer.variant.id;
      const hit = items.find((i) => i.id === id);
      if (hit) hit.quantity += pk.count; else items.push({ id, quantity: pk.count });
    }));
    if (!items.length) return;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); status.textContent = T.adding;
    try {
      const res = await fetch(`${D.routes.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: 'cart-drawer' }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || T.error);
      status.textContent = T.added;
      await refreshCart(data.sections, true);
    } catch (err) {
      status.textContent = err.message || T.error;
      try { await refreshCart(null, false); } catch (e2) { /* keep the message */ }
    } finally {
      btn.removeAttribute('aria-busy'); btn.disabled = false;
    }
  });
  $('[data-calc-share]').addEventListener('click', async () => {
    save();
    try { await navigator.clipboard.writeText(location.href); status.textContent = T.copied; } catch (e) { status.textContent = location.href; }
  });
  $('[data-calc-print]').addEventListener('click', () => window.print());

  load();
  renderChoices();
  render();
})();
